<template>
    <div class="cell" :style="{top: position.y + 'px', left: position.x + 'px'}" :class="type">
        <input ref="input"
               type="text"
               class="cell-input"
               :value="value"
               @change="changeValue"
        >
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';

    export default {
        name: "BoxListingInputCell",

        data() {
            return {
                value: 0,
                canClose: false,
            }
        },

        computed: {
            ...mapState('inputCell', [
                'activeCell',
                'position',
            ]),

            ...mapGetters('editor', [
                'footToPx',
                'fractionsDecimalRound',
            ]),

            type() {
                return this.activeCell?.type;
            },

            item() {
                return this.activeCell?.item;
            },

        },

        methods: {
            ...mapActions('editor', [
                'setHemSize',
            ]),

            ...mapActions('inputCell', [
                'clearActiveCell',
            ]),

            ...mapActions('line', [
                'simpleLineLengthChange',
            ]),

            ...mapActions('angles', [
                'setAngleChange',
            ]),

            initValue() {
                switch (this.type) {
                    case 'line':
                        this.value = this.fractionsDecimalRound(this.item.lengthInFeet || 0);
                        break;

                    case 'hem':
                        this.value = this.fractionsDecimalRound(this.item?.hem.size || 0);
                        break;

                    case 'angle':
                        this.value = this.item.angleSize || 0;
                        break;

                    default:
                        break;
                }
            },

            changeValue(event) {
                let newValue = +event.target.value;

                switch (this.type) {
                    case 'line':
                        this.changeLine(newValue);
                        break;

                    case 'hem':
                        this.changeHem(newValue);
                        break;

                    case 'angle':
                        this.changeAngle(newValue);
                        break;

                    default:
                        break;
                }

                this.value = newValue;
            },

            changeLine(newValue) {
                let line = this.item;

                let lineLengthDiff = (newValue - +this.value) * this.footToPx;

                let hideLineLength = line.fromPoint.lineLengthIsHidden;

                this.simpleLineLengthChange({ line, lineLengthDiff, hideLineLength });
            },

            changeHem(newValue) {
                this.setHemSize({ point: this.item, size: +newValue });
            },

            changeAngle(newValue) {
                const {pointCenter} = this.item;

                let angleDiff =  +newValue - +this.value;

                this.setAngleChange({pointCenter, angleDiff});
            },

            close() {
                this.clearActiveCell();
            },

            checkUnFocus(e) {
                if (!this.canClose) {
                    // ignore first click (it's double click at open)

                    this.canClose = true;
                    return;
                }

                const classList = e.target.classList;

                if (!classList.contains('cell') && !classList.contains('cell-input')) {
                    this.close();
                }
            },

            keyDown(e) {
                const keyCode = e.code;

                if(keyCode === 'Escape') {
                    this.close();
                }
            },

        },

        beforeMount() {
            this.initValue();
        },

        mounted() {
            this.$refs.input?.focus();

            window.addEventListener("click", this.checkUnFocus, false);
            window.addEventListener("keydown", this.keyDown, false);
        },

        beforeUnmount() {
            window.removeEventListener("click", this.checkUnFocus);
            window.removeEventListener("keydown", this.keyDown);
        },

    }
</script>

<style scoped>
    .cell {
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        transform: translate(-10px, -10px);
        width: 79px;
        height: 37px;
        padding: 10px 2px 10px 10px;
        line-height: 1;
        background: #fff;
    }

    .cell-input {
        width: 100%;
        padding: 0;
        border: 0;
        font-size: 16px;
    }

    .angle {
        width: 59px;
        transform: translate(70px, -10px);
        padding-right: 15px;
    }

    .angle .cell-input {
        text-align: center;
    }
</style>